'use strict';

var base = require('base/product/base');
var focusHelper = require('base/components/focus');
var modalMessage = require('../modalMessage.js');
var addWishlist = require('../components/buttonAddWishlist');

/**
 * Updates the Mini-Cart quantity value after the customer has pressed the "Add to Cart" button
 * @param {string} response - ajax response from clicking the add to cart button
 */
function handlePostCartAdd(response) {
    $('.minicart').trigger('count:update', response);
    var messageType = response.error ? 'alert-danger' : 'alert-success';

    if ($('.add-to-cart-messages').length === 0) {
        $('body').append(
            '<div class="add-to-cart-messages"></div>'
        );
    }

    $('.add-to-cart-messages').append(
        '<div class="alert ' + messageType + ' add-to-basket-alert text-center" role="alert">'
        + response.message
        + '</div>'
    );

    setTimeout(function () {
        $('.add-to-basket-alert').remove();
    }, 5000);
}

/**
 * Generates the modal window on the first call.
 *
 */
function getModalHtmlElement() {
    if ($('#editProductModal').length !== 0) {
        $('#editProductModal').remove();
    }
    var htmlString = '<!-- Modal -->'
        + '<div class="modal fade" id="editWishlistProductModal" tabindex="-1" role="dialog">'
        + '<span class="enter-message sr-only" ></span>'
        + '<div class="modal-dialog quick-view-dialog">'
        + '<!-- Modal content-->'
        + '<div class="modal-content">'
        + '<div class="modal-header">'
        + '    <button type="button" class="close pull-right" data-dismiss="modal">'
        + '        <span aria-hidden="true">&times;</span>'
        + '        <span class="sr-only"> </span>'
        + '    </button>'
        + '</div>'
        + '<div class="modal-body"></div>'
        + '<div class="modal-footer"></div>'
        + '</div>'
        + '</div>'
        + '</div>';
    $('body').append(htmlString);
}

/**
 * Parses the html for a modal window
 * @param {string} html - representing the body and footer of the modal window
 *
 * @return {Object} - Object with properties body and footer.
 */
function parseHtml(html) {
    var $html = $('<div>').append($.parseHTML(html));

    var body = $html.find('.product-quickview');
    var footer = $html.find('.modal-footer').children();

    return { body: body, footer: footer };
}

/**
 * replaces the content in the modal window for product variation to be edited.
 * @param {string} editProductUrl - url to be used to retrieve a new product model
 */
function fillModalElement(editProductUrl) {
    $('#editWishlistProductModal').spinner().start();

    $.ajax({
        url: editProductUrl,
        method: 'GET',
        dataType: 'json',
        success: function (data) {
            var parsedHtml = parseHtml(data.renderedTemplate);

            $('#editWishlistProductModal .modal-body').empty();
            $('#editWishlistProductModal .modal-body').html(parsedHtml.body);
            $('#editWishlistProductModal .modal-footer').html(parsedHtml.footer);
            $('#editWishlistProductModal .modal-header .close .sr-only').text(data.closeButtonText);
            $('#editWishlistProductModal .enter-message').text(data.enterDialogMessage);
            $('#editWishlistProductModal').modal('show');
            $('body').trigger('editwishlistproduct:ready');
            $.spinner().stop();
        },
        error: function () {
            $('#editWishlistProductModal').spinner().stop();
        }
    });
}

/**
 * show toast response
 * @param {Object} res - from the call to set the public status of a list or item in a list
 */
function showResponseMsg(res) {
    $.spinner().stop();
    var status;

    if (res.success) {
        status = 'alert-success';
    } else {
        status = 'alert-danger';
    }

    if ($('.add-to-wishlist-messages').length === 0) {
        $('body').append(
        '<div class="add-to-wishlist-messages "></div>'
        );
    }

    $('.add-to-wishlist-messages')
        .append('<div role="alert" class="add-to-wishlist-alert text-center ' + status + '">' + res.msg + '</div>');

    setTimeout(function () {
        $('.add-to-wishlist-messages').remove();
    }, 3000);
}

/**
 * toggles the public / private status of the item or wishlist item
 * @param {string} listID - the order model
 * @param {string} itemID - the customer model
 * @param {Object} callback - function to run if the ajax call returns with an
 *                        error so that the checkbox can be reset to it's original state
 */
function updatePublicStatus(listID, itemID, callback) {
    var url = $('#isPublicList').data('url');
    $.spinner().start();
    $.ajax({
        url: url,
        type: 'post',
        dataType: 'json',
        data: {
            listID: listID,
            itemID: itemID
        },
        success: function (data) {
            if (callback && !data.success) { callback(); }
            showResponseMsg(data, null);
        },
        error: function (err) {
            if (callback) { callback(); }
            showResponseMsg(err);
        }
    });
}
/**
 * @param {Object} $elementAppendTo - The element to append error html to
 * @param {string} msg - The error message
 * display error message if remove item from wishlist failed
 */
function displayErrorMessage($elementAppendTo, msg) {
    if ($('.remove-from-wishlist-messages').length === 0) {
        $elementAppendTo.append(
            '<div class="remove-from-wishlist-messages "></div>'
        );
    }
    $('.remove-from-wishlist-messages')
        .append('<div class="remove-from-wishlist-alert text-center alert-danger">' + msg + '</div>');

    setTimeout(function () {
        $('.remove-from-wishlist-messages').remove();
    }, 3000);
}

/**
 * renders the list up to a given page number
 * @param {number} pageNumber - current page number
 * @param {boolean} spinner - if the spinner has already started
 * @param {string} focusElementSelector - selector of the element to focus on
 */
function renderNewPageOfItems(pageNumber, spinner, focusElementSelector) {
    var publicView = $('.wishlistItemCards').data('public-view');
    var listUUID = $('.wishlistItemCards').data('uuid');
    var url = $('.wishlistItemCards').data('href');
    if (spinner) {
        $.spinner().start();
    }
    var scrollPosition = document.documentElement.scrollTop;
    var newPageNumber = pageNumber;
    $.ajax({
        url: url,
        method: 'get',
        data: {
            pageNumber: ++newPageNumber,
            publicView: publicView,
            id: listUUID
        }
    }).done(function (data) {
        var action = $('body .page').data('action');
        if(action === 'Wishlist-Show'){
            $('.page').empty();
            $('.footer_block').remove();
            $('body .page').append(data);
        }else{
            $('.home_page').empty();
            $('.footer_block').remove();
            $('body .home_page').append(data);
        }
        

        if (focusElementSelector) {
            $(focusElementSelector).focus();
        } else {
            document.documentElement.scrollTop = scrollPosition;
        }
    }).fail(function () {
        $('.more-wl-items').remove();
    });
    $.spinner().stop();
}

module.exports = {
    removeFromWishlist: function () {
        $('body').on('click', '.remove-from-wishlist', function (e) {
            e.preventDefault();
            var url = $(this).data('url');
            var elMyAccount = $('.account-wishlist-item').length;

            // If user is in my account page, call removeWishlistAccount() end point, re-render wishlist cards
            if (elMyAccount > 0) {
                $('.wishlist-account-card').spinner().start();
                $.ajax({
                    url: url,
                    type: 'post',
                    dataType: 'html',
                    data: {},
                    success: function (html) {
                        $('.wishlist-account-card>.card').remove();
                        $('.wishlist-account-card').append(html);
                        $('.wishlist-account-card').spinner().stop();
                    },
                    error: function () {
                        var $elToAppend = $('.wishlist-account-card');
                        $elToAppend.spinner().stop();
                        var msg = $elToAppend.data('error-msg');
                        displayErrorMessage($elToAppend, msg);
                    }
                });
            // else user is in wishlist landing page, call removeProduct() end point, then remove this card
            } else {
                $.spinner().start();
                $.ajax({
                    url: url,
                    type: 'post',
                    dataType: 'json',
                    data: {},
                    success: function () {
                        // var pageNumber = $('.wishlistItemCardsData').data('page-number') - 1;
                        // renderNewPageOfItems(pageNumber, false);
                        location.reload();
                    },
                    error: function () {
                        $.spinner().stop();
                        var $elToAppendWL = $('.wishlistItemCards');
                        var msg = $elToAppendWL.data('error-msg');
                        displayErrorMessage($elToAppendWL, msg);
                    }
                });
            }
        });
    },

    viewProductViaEdit: function () {
        $('body').on('click', '.edit-add-to-wishlist .edit', function (e) {
            e.preventDefault();

            var editProductUrl = $(this).attr('href');
            $(e.target).trigger('editwishlistproduct:show');
            getModalHtmlElement();
            fillModalElement(editProductUrl);
        });
    },

    viewProductViaSelectAttribute: function () {
        $('body').on('click', '.select-attributes-btn', function (e) {
            e.preventDefault();

            var editProductUrl = $(this).data('get-product-url');
            getModalHtmlElement();
            fillModalElement(editProductUrl);
        });
    },

    focusEditWishlistProductModal: function () {
        $('body').on('shown.bs.modal', '#editWishlistProductModal', function () {
            $('#editWishlistProductModal').siblings().attr('aria-hidden', 'true');
            $('#editWishlistProductModal .close').focus();
        });
    },

    onClosingEditWishlistProductModal: function () {
        $('body').on('hidden.bs.modal', '#editWishlistProductModal', function () {
            $('#editWishlistProductModal').remove();
            $('.modal-backdrop').remove();
            $('body').removeClass('modal-open');

            $('#editWishlistProductModal').siblings().attr('aria-hidden', 'false');
        });
    },

    trapEditWishlistProductModalFocus: function () {
        $('body').on('keydown', '#editWishlistProductModal', function (e) {
            var focusParams = {
                event: e,
                containerSelector: '#editWishlistProductModal',
                firstElementSelector: '.close',
                lastElementSelector: '.btn-update-wishlist-product',
                nextToLastElementSelector: '.select-size'
            };
            focusHelper.setTabNextFocus(focusParams);
        });
    },

    updateWishlistUpdateButton: function () {
        $('body').on('product:updateAddToCart', function (e, response) {
            response.$productContainer.find('.btn-update-wishlist-product').attr('disabled', !response.product.readyToOrder || !response.product.available);
        });
    },

    updateWishListItem: function () {
        $('body').on('click', '.btn-update-wishlist-product', function (e) {
            e.preventDefault();

            var updateButtonBlock = $(this).closest('.wishlist-item-update-button-block').find('.update-wishlist-url');
            var updateProductUrl = updateButtonBlock.val();
            var uuid = updateButtonBlock.data('uuid');

            var form = {
                uuid: uuid,
                pid: base.getPidValue($(this))
            };

            $('#editWishlistProductModal').spinner().start();

            $.ajax({
                url: updateProductUrl,
                type: 'post',
                context: this,
                data: form,
                dataType: 'json',
                success: function () {
                    $.spinner().start();
                    $('#editWishlistProductModal').spinner().stop();
                    $('#editWishlistProductModal').remove();
                    $('.modal-backdrop').remove();
                    $('body').removeClass('modal-open');
                    var pageNumber = $('.wishlistItemCardsData').data('page-number') - 1;
                    renderNewPageOfItems(pageNumber, false, '.product-info .edit-add-to-wishlist .edit:first');
                },
                error: function () {
                    var msg = $('.btn-update-wishlist-product').data('error-msg');

                    $('#editWishlistProductModal').spinner().stop();
                    $('#editWishlistProductModal').remove();
                    $('.modal-backdrop').remove();
                    $('body').removeClass('modal-open');

                    if ($('.update-wishlist-messages').length === 0) {
                        $('body').append(
                            '<div class="update-wishlist-messages "></div>'
                        );
                    }

                    $('.update-wishlist-messages')
                        .append('<div class="update-wishlist-alert text-center alert-danger">' + msg + '</div>');

                    setTimeout(function () {
                        $('.update-wishlist-messages').remove();
                    }, 5000);
                }
            });
        });
    },

    toggleWishlistStatus: function () {
        $('#isPublicList').on('click', function () {
            var listID = $('#isPublicList').data('id');
            updatePublicStatus(listID, null, null);
        });
    },

    toggleWishlistItemStatus: function () {
        $('body').on('click', '.wishlist-item-checkbox', function () {
            var itemID = $(this).closest('.wishlist-hide').find('.custom-control-input').data('id');
            var el = $(this).siblings('input');
            var resetCheckBox = function () {
                return el.prop('checked')
                    ? el.prop('checked', false)
                    : el.prop('checked', true);
            };

            updatePublicStatus(null, itemID, resetCheckBox);
        });
    },

    addToCartFromWishlist: function () {
        $('body').on('click', '.add-to-cart', function () {
            var pid;
            var addToCartUrl;
            var pidsQty;

            $('body').trigger('product:beforeAddToCart', this);

            pid = $(this).data('pid');
            addToCartUrl = $(this).data('url');
            pidsQty = parseInt($(this).closest('.product-info').find('.quantity').val(), 10);

            var form = {
                pid: pid,
                quantity: pidsQty
            };

            if ($(this).data('option')) {
                form.options = JSON.stringify($(this).data('option'));
            }

            $(this).trigger('updateAddToCartFormData', form);
            if (addToCartUrl) {
                $.ajax({
                    url: addToCartUrl,
                    method: 'POST',
                    data: form,
                    success: function (data) {
                        if (data.error === true) {
                            $.spinner().stop();
                            modalMessage.displayModalMessage(data.message);
                        } else {
                            handlePostCartAdd(data);
                            $(".header__cart-number.cart-number.quantity-total").text(parseInt(data.cart.numItems));
                            if (parseInt(data.cart.numItems) > 0) {
                                $('.header__cart-number.cart-number.quantity-total').removeClass('d-none');
                            } else {
                                $('.header__cart-number.cart-number.quantity-total').addClass('d-none');
                            }
                            $("body").trigger("product:afterAddToCart", data);
                            $.spinner().stop();
                            base.miniCartReportingUrl(data.reportingURL);
                        }
                    },
                    error: function () {
                        $.spinner().stop();
                    }
                });
            }
        });
    },
    moreWLItems: function () {
        $('body').on('click', '.more-wl-items', function () {
            var pageNumber = $('.wishlistItemCardsData').data('page-number');
            renderNewPageOfItems(pageNumber, true);
        });
    },
    copyWishlistLink: function () {
        $('body').on('click', '#copyShareUrlBtn', function () {
            var $btn = $('#copyShareUrlBtn');
            var shareUrl = $btn.data('url');
            navigator.clipboard.writeText(shareUrl);
            $('.copy-link-message').removeClass('d-none');
            setTimeout(function () {
                $('.copy-link-message').addClass('d-none');
            }, 3000);
        });
    },
    submitWishlistSearch: function () {
        $('body').on('click', '#wishlist-search button', function (e) {
            var firstName = $('#wishlist-search-first-name').val();
            var lastName = $('#wishlist-search-last-name').val();
            var email = $('#wishlist-search-email').val();

            if ((!firstName && !lastName && !email)
                || (firstName && !lastName && !email)
                || (!firstName && lastName && !email)) {
                e.preventDefault();
                $('.wishlist-error-search div').addClass('alert alert-danger');
                var errorText = $('.wishlist-error-search').data('error-msg');
                $('.wishlist-error-search div').html(errorText);
            }
        });
    },
    moreWLSearchResults: function () {
        $('body').on('click', '.more-wl-results', function () {
            var firstName = $(this).data('search-fname');
            var lastName = $(this).data('search-lname');
            var pageNumber = $(this).data('page-number');
            var uuids = [];
            $('.wl-hit').each(function () {
                uuids.push($(this).find('a').data('id'));
            });
            var url = $(this).data('url');
            $.spinner().start();
            $.ajax({
                url: url,
                method: 'POST',
                data: {
                    firstName: firstName,
                    lastName: lastName,
                    uuids: JSON.stringify(uuids),
                    pageNumber: ++pageNumber
                },
                success: function (data) {
                    if (data.results.changedList) {
                        $('.wl-hits .wl-hit').remove();
                    }
                    $('#result-count').html(data.results.totalString);
                    data.results.hits.forEach(function (hit) {
                        var divString = '<div class="row wl-hit">' +
                            '<div class="text-left col-6">' +
                                hit.firstName + ' ' + hit.lastName +
                            '</div>' +
                            '<div class="text-right col-6">' +
                                '<a href="' + hit.url + '" title="' + hit.urlTitle + '" data-id="' + hit.id + '">' +
                                    hit.urlText +
                                '</a>' +
                            '</div>' +
                            '</div>';
                        $('.wl-hits').append(divString);
                    });
                    if (data.results.showMore) {
                        $('.find-another-wl .more-wl-results').data('page-number', data.results.pageNumber);
                    } else {
                        $('.find-another-wl .more-wl-results').remove();
                    }
                    $.spinner().stop();
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        });
    },
    favoriteModal: function() {
        $(document).on('click', '.card__icon, .master_favorite', function (e) {
            var url = $(this).data('url');
            window.localStorage.setItem('URL_Wishlist', url );
            $.ajax({
                method: 'get',
                url: url,
                success: function (response) {
                    $('.modal-main').html(response.renderTemplate);
                }
            });
        });
    },

    addOrRemoveWishList: addWishlist.addOrRemoveWishList
};

jQuery('.brand_add').click(function(e) {
    jQuery('.brand_block_3').removeClass('d-none');
    jQuery('.brand_block_1').addClass('d-none');
    jQuery('#tab-item02').addClass('sp_poshi');
    return false;
  });
  jQuery('.brand_cancel').click(function(e) {
    jQuery('.brand_block_2').addClass('d-none');
    jQuery('.brand_block_1').removeClass('d-none');
    $('body, html').animate({
        scrollTop: 0
    }, 300);
    return false;
  });
  jQuery('.brand_delete').click(function(e) {
    var url = $(this).data('url')
    var fd = new FormData(); 
    var listStores = []
     var brandWishListSize = $('input[name=DeleteStore]').length;
     $('input[name=DeleteStore]:checked').each(function(){
        listStores.push($(this).val())
     })
     fd.append('listStores',listStores)
     $.ajax({
        url: url,
        type: 'POST',
        processData: false,
        contentType: false,
        data: fd,
        success: function (data) {
            jQuery('.brand_block_2').addClass('d-none');
            jQuery('.brand_block_1').removeClass('d-none');
            $('.brand_link').has('input[name=DeleteStore]:checked').remove()
            listStores.map((id) => {
                $('#'+ id).remove()
                $('#'+ id +'-add').prop('checked',false)
                $('#'+ id +'-add').prop('disabled',false)
            });
            if (listStores.length === brandWishListSize) {
                $('#wishlist-empty-text').removeClass('d-none')
                $('.btn_back-to-account').removeClass('just-space')
                $('.brand_edit').addClass('d-none')
            }
            $('body, html').animate({
                scrollTop: 0
            }, 300);
        },
        error: function () {
            alert(hihi)
        }
    });
    return false;
  });
  jQuery('.brand_edit').click(function(e) {
    jQuery('.brand_block_1').addClass('d-none');
    jQuery('.brand_block_2').removeClass('d-none');
    return false;
  });
  jQuery('.sp_close').click(function(e) {
    jQuery('.brand_block_3').addClass('d-none');
    jQuery('.brand_block_1').removeClass('d-none');
    jQuery('#tab-item02').removeClass('sp_poshi');
    return false;
  });

  jQuery('.brand_add_input').click(function(e) {
    e.preventDefault();
    var url = $(this).data('url')
    var fd = new FormData(); 
    var listStores = [];
    var list_store_name = [];
    var list_store_katakana = [];
     $('input[name=AddStore]:checked').each(function(){
        listStores.unshift($(this).val());
        list_store_name.unshift($(this).data('name'));
        list_store_katakana.unshift($(this).data('katakana'));
     })
     fd.append('listStores',listStores)
     $.ajax({
        url: url,
        type: 'POST',
        processData: false,
        contentType: false,
        data: fd,
        success: function (data) {
            jQuery('.brand_block_3').addClass('d-none');
            jQuery('.brand_block_1').removeClass('d-none');
            jQuery('#tab-item02').removeClass('sp_poshi');
            $(document).scrollTop(0);
            $('.list_store_wishlist').html('')
            $('.list_store-toremove').html('')
            listStores.map((sid, index) => {
                $(`input[value=${sid}]`).attr('disabled', 'disabled')
                $('.list_store_wishlist').prepend(`<div class="brand_link" id="${sid}"><a href="#"><p>${list_store_name[index]}</p><p class="text_gray">${list_store_katakana[index]}</p></a></div>`)
                $('.list_store-toremove').prepend(`<div class="brand_link"><label class="flexbox radio_label align-center"><input type="checkbox" name="DeleteStore"value="${sid}"><span class="radio-mark_2"></span><div><p>${list_store_name[index]}</p><p class="text_gray">${list_store_katakana[index]}</p></div></label></div>`)
            })
            $('#wishlist-empty-text').addClass('d-none')
            $('.brand_edit').removeClass('d-none')
            $('.btn_back-to-account').addClass('just-space');
            //datalayer
            var HeaderDataLayer = $('input[name="dataLayer"]').val();
            if (HeaderDataLayer) {
                HeaderDataLayer = JSON.parse(HeaderDataLayer);
            }
            if(data.items && data.items.length > 0){
                dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
                dataLayer.push({
                    user_id: HeaderDataLayer && HeaderDataLayer.user_properties ? HeaderDataLayer.user_properties.customer_id : '',
                    event: "add_to_wishlist_storetype",
                    ecommerce: {
                        currency: 'JPY',
                        items: data.items
                    }
                });
            }
            location.reload();
        },
        error: function (e) {
            console.warn(e)
        }
    });
    return false;
  
});

//stock request
$('.stock_request_wishlist').on('click', function(){
    var url = $(this).data('url')
    var pid = $(this).data('pid')
    var cid = $(this).data('cid')
    var email = $(this).data('email');
    var imageClose = $(this).data('imageurl');

    //Get user info from data layer
    var HeaderDataLayer = $('input[name="dataLayer"]').val();
    if (HeaderDataLayer) {
        HeaderDataLayer = JSON.parse(HeaderDataLayer);
    }

    var form ={
        email : email,
        pid: pid,
        cid: cid
    };
    $.ajax({
        url: url,
        method: "POST",
        data: form,
        success: function (data) {
            if (data.success) {
                var productDataLayer = data.productDataLayer;
                dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
                dataLayer.push({
                    user_id: HeaderDataLayer && HeaderDataLayer.user_properties ? CryptoJS.SHA256(HeaderDataLayer.user_properties.customer_id).toString(CryptoJS.enc.Hex) : '',
                    event: data.isComingSoon ? 'add_to_arrival_info' : 'add_to_restock_info' ,
                    ecommerce: {
                        currency: 'JPY',
                        value: productDataLayer.ecommerceValue,
                        items: productDataLayer.items
                    },
                    members_id: HeaderDataLayer && HeaderDataLayer.user_properties ? HeaderDataLayer.user_properties.customer_id : ''
                });
            }
            modalMessage.displayModalMessage(data.message,imageClose);
        },
        error: function (err) {
            modalMessage.displayModalMessage(data.message,imageClose);
        },
    });
})

$('.modal-remove-all-wishlist').on('click',function(){
    // 黒い背景をbody内に追加
    $('body').append('<div class="cart_modal_bg"></div>');
    $('.cart_modal_bg').fadeIn();

    $('.cart_modal_bg, .modal_confirm_close, .cancel_remove, .remove-all-wishlist').off().click(function () {
        $('#remove_wishlist_modal').css('display', 'none')
        $('.cart_modal').fadeOut();
        $('.cart_modal_bg').fadeOut('slow', function () {
            $('.cart_modal_bg').remove();
        });
        $('body').removeClass('is-open');
    });

    $('#remove_wishlist_modal').css('display', 'block')
})

$(function () {
    $(document).on('click', '.card__icon, .master_favorite', function (e) {
        event.preventDefault();
        const url = new URL(window.location);
        url.searchParams.set('openmodal', '1');
        history.replaceState({}, '', url);
        $('body').addClass('lock_scroll');
        $('.wp-modal').addClass('modal-fade');
    });

    $('.modal-close, .modal-overlay').on('click', function () {
        const url = new URL(window.location);
        $('html').css('overflow', 'initial').css('margin-right', '0').css('touch-action', '');
        url.searchParams.delete('openmodal');
        history.replaceState({}, '', url);
        $('.wp-modal').removeClass('modal-fade');
        setTimeout(() => {
            $('.modal-main').empty();
        }, 500);
        setTimeout(() => {
            $('body').removeClass('lock_scroll');
        }, 350);
    });

    $(document).on('click', '.modal_error_close, .cart_modal_bg,  .modal.modal_error', function (e) {
        $('.modal-backdrop').remove();
        const url = new URL(window.location);
        url.searchParams.delete('openmodal');
        history.replaceState({}, '', url);
        $('.wp-modal').removeClass('modal-fade');
        setTimeout(() => {
            $('.modal-main').empty();
            $('body').removeClass('lock_scroll');
        }, 500);
    });

    $(document).on('click', '.add-wp-non-login', function(){
        var parent = $(this).closest('.size-item');
        $('.add-wp-extend.extended').not($(parent).children('.add-wp-extend.extended')).removeClass('extended');
        var windowLocation = window.location;
        var redirect = windowLocation.href;
        var url = $(this).data('url');
        $('.wishlist_redirect_login').attr('href',url+ '?isBack=true&redirect='+redirect );
        $(parent).children('.add-wp-extend').toggleClass('extended');
    } )
    $(document).on('click', '.add-pd-non-login img', function(){
        var redirect = window.location.href;
        var url = $('.add-pd-non-login').data('url');
        $('.wishlist_redirect_login').attr('href',url+'?redirect='+redirect);
        var parent = $(this).closest('.add-pd-non-login');
        $('.add-pd-extend.extended').not($(parent).siblings('.add-pd-extend.extended')).removeClass('extended');
        $(parent).siblings('.add-pd-extend').toggleClass('extended');
    } )
    $(document).on('click', '.add-staff-non-login img', function(){
        var redirect = window.location.href;
        var url = $('.add-staff-non-login').data('url');
        $('.wishlist_redirect_login').attr('href',url+'?redirect='+redirect);
        $('.add-staff-extend.extended').not($(this).siblings('.add-staff-extend.extended')).removeClass('extended');
        $(this).siblings('.add-staff-extend').toggleClass('extended');
        setTimeout(function () {
            $('.add-staff-extend.extended').removeClass('extended');
            clearTimeout();
        }, 3000);
    } )
    $(document).on('click', '.add-staff-detail-non-login', function(){
        var redirect = window.location.href;
        var casePage = $(this).data('case');
        var url = $('.add-staff-detail-non-login').data('url');
        $('.wishlist_redirect_login').attr('href',url+'?redirect='+redirect);
        
        switch (casePage) {
            // for styling detail main image
            case 'main-image':
                $(this).closest('.group-wl').find('.add-staff-detail-extend').toggleClass('extended');
                break;
            default:
                $(this).children().children('.add-staff-detail-extend').toggleClass('extended');
                break;
        }
     
        setTimeout(function () {
            $('.add-staff-extend.extended').removeClass('extended');
        }, 3000);
    })
    $(document).on('click', '.add-wp-extend-btn', function(){
        $('.add-staff-detail-extend').removeClass('extended');
        setTimeout(function () {
            $('.add-staff-extend.extended').removeClass('extended');
        }, 3000);
    })
    // List of selectors to set min-height
    var selectors = [
        '.wishList-container .wish_text p:first-child',
        '.wishList-container .wish_text p:nth-child(2)',
        '.wishList-container .wish_text p:nth-child(4)',
        '.wishList-container .wish_text p:nth-child(6)'
    ];
    
    selectors.forEach(function(selector) {
        setMinHeight(selector);
    });
})

$('body').on('click', '.main_ss_detail .add-staff-styling-no-login img', function () {
    $('.staff-styling-add-wishlist').not($(this).closest('.add-staff-styling-no-login').find('.staff-styling-add-wishlist')).addClass('d-none');
    var redirect = window.location.href;
    var url = $('.staff-styling-url-redirect').attr('href');
    $('.staff-styling-url-redirect').attr('href', url + '?redirect=' + redirect);
    $(this).closest('.add-staff-styling-no-login').find('.staff-styling-add-wishlist').toggleClass('d-none');
});

function setMinHeight(selector) {
    var maxHeight = 0;
    $(selector).css('height', 'auto').each(function () {
        var currHeight = $(this).outerHeight();
        if (currHeight > maxHeight) {
            maxHeight = currHeight;
        }
    });
    $(selector).css('min-height', maxHeight + 'px');
}
